/* SORELI i18n core — découpe le DOM en "unités" de texte (phrases avec leurs balises inline)
   et les remplace par leur traduction. Le français n'est jamais modifié : ce fichier n'est
   chargé que sur /es et /it. */
(function (G) {
  var INL = { STRONG: 1, B: 1, EM: 1, I: 1, U: 1, SMALL: 1, SPAN: 1, A: 1, SUP: 1, SUB: 1, MARK: 1, S: 1, FONT: 1, ABBR: 1, Q: 1, CITE: 1, BDI: 1, TIME: 1 };
  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, SVG: 1, IFRAME: 1, CANVAS: 1, VIDEO: 1, AUDIO: 1, PICTURE: 1, SELECT: 0, CODE: 1, PRE: 1, TEMPLATE: 0 };
  var NUM = /\d+(?:[.,   ]\d+)*/g;
  var LETTERS = /[A-Za-zÀ-ÿ]{2}/;

  function norm(t) { return t.replace(/[\s ]+/g, ' '); }

  /* inline "pur" : balise inline dont tous les descendants sont du texte ou des inlines purs (ou <br>) */
  function pure(el) {
    if (el.nodeType !== 1 || !INL[el.tagName]) return false;
    if (el.hasAttribute('data-sx-notr')) return false;
    var hasText = false;
    for (var c = el.firstChild; c; c = c.nextSibling) {
      if (c.nodeType === 3) { if (c.nodeValue.trim()) hasText = true; continue; }
      if (c.nodeType === 8) continue;
      if (c.nodeType !== 1) return false;
      if (c.tagName === 'BR') continue;
      if (!pure(c)) return false;
      hasText = true;
    }
    return hasText;
  }
  function isRunNode(n) { return n.nodeType === 3 || (n.nodeType === 1 && (n.tagName === 'BR' || pure(n))) || n.nodeType === 8; }

  /* Sérialise une suite de noeuds en clé : texte + <0>..</0> + <br> ; nombres -> {0},{1} */
  function serialize(nodes) {
    var els = [], parts = [];
    (function ser(list) {
      for (var i = 0; i < list.length; i++) {
        var n = list[i];
        if (n.nodeType === 3) parts.push(n.nodeValue);
        else if (n.nodeType === 1 && n.tagName === 'BR') parts.push('<br>');
        else if (n.nodeType === 1) {
          var k = els.length; els.push(n);
          parts.push('<' + k + '>'); ser(Array.prototype.slice.call(n.childNodes)); parts.push('</' + k + '>');
        }
      }
    })(nodes);
    var raw = norm(parts.join(''));
    raw = raw.replace(/\s*<br>\s*/g, '<br>').replace(/<(\d+)>\s+/g, ' <$1>').replace(/\s+<\/(\d+)>/g, '</$1> ');
    raw = norm(raw).trim();
    var nums = [];
    var key = raw.replace(/(<\/?\d+>|<br>)|\d+(?:[.,\u202F\u00A0 ]\d+)*/g, function (m, tag) { if (tag) return tag; nums.push(m); return '{' + (nums.length - 1) + '}'; });
    return { key: key, nums: nums, els: els };
  }

  /* Trouve les "runs" (suites de texte + inlines purs) dans un conteneur, récursivement */
  function collectRuns(root, out) {
    out = out || [];
    if (root.nodeType !== 1 && root.nodeType !== 11) return out;
    if (root.nodeType === 1 && (SKIP[root.tagName] || root.hasAttribute('data-sx-notr') || root.isContentEditable)) return out;
    var run = [];
    var flush = function () {
      if (run.length) {
        var hasT = run.some(function (n) { return n.nodeType === 3 ? n.nodeValue.trim() : n.nodeType === 1 && n.tagName !== 'BR'; });
        if (hasT) out.push(run);
        run = [];
      }
    };
    for (var c = root.firstChild; c; c = c.nextSibling) {
      if (isRunNode(c)) { run.push(c); continue; }
      flush();
      if (c.nodeType === 1) {
        if (c.tagName === 'TEMPLATE' && c.content) collectRuns(c.content, out);
        else collectRuns(c, out);
        if (c.shadowRoot) collectRuns(c.shadowRoot, out);
      }
    }
    flush();
    return out;
  }

  /* Parse une traduction "Añade <0>1 joya</0> y <1>…</1>" en tokens */
  function tokens(s) {
    var re = /<(\/?)(\d+)>|<br\s*\/?>/g, out = [], last = 0, m;
    while ((m = re.exec(s))) {
      if (m.index > last) out.push({ t: 'txt', v: s.slice(last, m.index) });
      if (m[0].indexOf('br') > -1) out.push({ t: 'br' });
      else out.push({ t: m[1] ? 'close' : 'open', k: +m[2] });
      last = re.lastIndex;
    }
    if (last < s.length) out.push({ t: 'txt', v: s.slice(last) });
    return out;
  }

  function applyRun(run, info, tr, mark) {
    var nums = info.nums;
    tr = tr.replace(/\{(\d+)\}/g, function (m, i) { return nums[+i] != null ? nums[+i] : m; });
    var first = run[0], last = run[run.length - 1], parent = first.parentNode;
    if (!parent) return;
    var lead = first.nodeType === 3 && /^[\s ]/.test(first.nodeValue) ? ' ' : '';
    var trail = last.nodeType === 3 && /[\s ]$/.test(last.nodeValue) ? ' ' : '';
    var marker = document.createTextNode('');
    parent.insertBefore(marker, first);
    var toks = tokens(tr);
    var frag = document.createDocumentFragment(), stack = [frag];
    var used = {};
    toks.forEach(function (tk) {
      var top = stack[stack.length - 1];
      if (tk.t === 'txt') { var tn = document.createTextNode(tk.v); if (mark) mark(tn); top.appendChild(tn); }
      else if (tk.t === 'br') top.appendChild(document.createElement('br'));
      else if (tk.t === 'open') {
        var el = info.els[tk.k];
        if (!el || used[tk.k]) { el = el ? el.cloneNode(false) : document.createElement('span'); }
        else { used[tk.k] = 1; while (el.firstChild) el.removeChild(el.firstChild); }
        top.appendChild(el); stack.push(el);
      } else if (tk.t === 'close') { if (stack.length > 1) stack.pop(); }
    });
    if (lead) frag.insertBefore(document.createTextNode(' '), frag.firstChild);
    if (trail) frag.appendChild(document.createTextNode(' '));
    run.forEach(function (n) { if (n.parentNode === parent) parent.removeChild(n); });
    parent.insertBefore(frag, marker);
    parent.removeChild(marker);
  }

  var ATTRS = ['placeholder', 'aria-label', 'alt', 'title', 'data-tooltip'];

  G.SXI18N = { serialize: serialize, collectRuns: collectRuns, applyRun: applyRun, norm: norm, ATTRS: ATTRS, NUM: NUM, LETTERS: LETTERS, pure: pure };
})(typeof window !== 'undefined' ? window : this);


/* SORELI i18n runtime — traduit le site en espagnol / italien (chargé uniquement sur /es et /it). */
(function () {
  var S = window.SXI18N, D = window.SX_DICT || {};
  if (!S) return;
  var done = new WeakSet();
  var mark = function (n) { done.add(n); };
  var loading = function () { return document.readyState === 'loading'; };
  /* éléments que les scripts du thème réécrivent au chargement (ex. offre Sérénité) : traduits après eux */
  var DEFER = '.soreli-points', deferReady = false;

  function textNodes(nodes, acc) {
    acc = acc || [];
    nodes.forEach(function (n) { if (n.nodeType === 3) acc.push(n); else if (n.nodeType === 1) textNodes(Array.prototype.slice.call(n.childNodes), acc); });
    return acc;
  }

  function tryRun(run, allowFallback) {
    if (!deferReady) { var pe = run[0].parentElement; if (pe && pe.closest && pe.closest(DEFER)) return; }
    var tn = textNodes(run);
    if (!tn.length || tn.every(function (t) { return done.has(t) || !t.nodeValue.trim(); })) return;
    var info = S.serialize(run);
    if (!info.key || !S.LETTERS.test(info.key)) return;
    var tr = D[info.key];
    if (tr != null) {
      if (tr === info.key) { tn.forEach(mark); return; }
      S.applyRun(run, info, tr, mark);
      return;
    }
    if (!allowFallback || run.length < 1) return;
    /* repli : on traduit morceau par morceau (valeurs dynamiques : « Or », « Argent »…) */
    run.forEach(function (n) {
      if (n.nodeType === 3) { if (run.length > 1) tryRun([n], false); }
      else if (n.nodeType === 1 && n.tagName !== 'BR') S.collectRuns(n).forEach(function (r) { tryRun(r, true); });
    });
  }

  function attrs(root) {
    if (!root.querySelectorAll) return;
    var els = root.nodeType === 1 ? [root].concat(Array.prototype.slice.call(root.querySelectorAll('*'))) : Array.prototype.slice.call(root.querySelectorAll('*'));
    els.forEach(function (el) {
      S.ATTRS.forEach(function (a) {
        if (!el.hasAttribute || !el.hasAttribute(a)) return;
        var v = S.norm(el.getAttribute(a)).trim(), nums = [];
        var k = v.replace(/\d+(?:[.,   ]\d+)*/g, function (m) { nums.push(m); return '{' + (nums.length - 1) + '}'; });
        var t = D[k];
        if (t != null && t !== k) el.setAttribute(a, t.replace(/\{(\d+)\}/g, function (m, i) { return nums[+i] != null ? nums[+i] : m; }));
      });
      if (el.tagName === 'INPUT' && /submit|button/.test(el.type) && el.value) { var t2 = D[S.norm(el.value).trim()]; if (t2) el.value = t2; }
    });
  }

  function container(n) {
    var c = n.nodeType === 1 ? n : n.parentNode;
    while (c && c.nodeType === 1 && (S.pure(c) || c.tagName === 'BR')) c = c.parentNode;
    return c;
  }

  /* images avec du texte : version traduite (window.SX_IMG = { 'fichier-fr.jpg': 'fichier-traduit.jpg?v=…' }) */
  var IMG = window.SX_IMG || {}, IMGK = Object.keys(IMG);
  var IMG_ATTRS = ['src', 'srcset', 'data-src', 'data-srcset', 'href', 'data-zoom', 'data-zoom-src', 'data-original-src', 'data-image'];
  function swapEl(el) {
    if (!el.getAttribute) return;
    IMG_ATTRS.forEach(function (a) {
      var v = el.getAttribute(a); if (!v) return;
      var nv = v;
      IMGK.forEach(function (k) { if (nv.indexOf(k) > -1) nv = nv.split(k).join(IMG[k]).replace(/(\?v=\d+)\?v=\d+/g, '$1').replace(/(\?v=\d+)\?v=\d+/g, '$1'); });
      if (nv !== v) el.setAttribute(a, nv);
    });
  }
  /* vidéos traduites (window.SX_VID = { 'identifiant-vidéo-fr': { src: '…mp4', poster: '…jpg' } }) */
  var VID = window.SX_VID || {}, VIDK = Object.keys(VID);
  function swapVid(el) {
    if (!VIDK.length || !el.getAttribute) return;
    var tag = el.tagName;
    if (tag === 'SOURCE') {
      var s = el.getAttribute('src') || '';
      for (var i = 0; i < VIDK.length; i++) if (s.indexOf(VIDK[i]) > -1) {
        el.setAttribute('src', VID[VIDK[i]].src);
        var v = el.parentNode;
        if (v && v.tagName === 'VIDEO') { try { v.load(); if (v.autoplay || v.hasAttribute('autoplay')) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } } catch (e) {} }
        break;
      }
    } else if (tag === 'VIDEO') {
      var po = el.getAttribute('poster') || '', sr = el.getAttribute('src') || '';
      for (var j = 0; j < VIDK.length; j++) {
        if (po.indexOf(VIDK[j]) > -1 && VID[VIDK[j]].poster) el.setAttribute('poster', VID[VIDK[j]].poster);
        if (sr.indexOf(VIDK[j]) > -1) { el.setAttribute('src', VID[VIDK[j]].src); try { el.load(); } catch (e) {} }
      }
    }
  }
  function imgs(root) {
    if (!root || !root.querySelectorAll) return;
    if (VIDK.length) { if (root.nodeType === 1) swapVid(root); root.querySelectorAll('video,source').forEach(swapVid); }
    if (!IMGK.length) return;
    if (root.nodeType === 1) swapEl(root);
    root.querySelectorAll('img,source,a,[data-src],[data-srcset],[data-zoom],[data-image]').forEach(swapEl);
  }

  function processRoot(root, allowFallback) {
    if (!root) return;
    if (root.nodeType === 1 && /^(SCRIPT|STYLE|NOSCRIPT)$/.test(root.tagName)) return;
    S.collectRuns(root).forEach(function (r) { tryRun(r, allowFallback); });
    attrs(root);
    imgs(root);
    shadows(root);
  }

  /* contenus dans des « shadow DOM » (ex. bandeau cookies Consentmo) : on les observe aussi */
  var watched = new WeakSet();
  function shadows(root) {
    if (!root || !root.querySelectorAll) return;
    var list = root.nodeType === 1 ? [root] : [];
    list = list.concat(Array.prototype.slice.call(root.querySelectorAll('*')));
    list.forEach(function (el) {
      var sr = el.shadowRoot;
      if (!sr || watched.has(sr)) return;
      watched.add(sr);
      try { mo.observe(sr, OPTS); } catch (e) {}
      S.collectRuns(sr).forEach(function (r) { tryRun(r, !loading()); });
      attrs(sr); shadows(sr);
    });
  }

  function title() {
    var t = S.norm(document.title || '').trim();
    if (D[t] && D[t] !== t) document.title = D[t];
    var md = document.querySelector('meta[name="description"]');
    if (md) { var m = S.norm(md.content || '').trim(); if (D[m]) md.content = D[m]; }
  }

  var busy = false;
  var mo = new MutationObserver(function (records) {
    if (busy) return;
    var set = new Set();
    records.forEach(function (r) {
      if (r.type === 'childList') {
        r.addedNodes.forEach(function (n) {
          if (n.nodeType === 3 && done.has(n)) return;
          if (n.nodeType === 1 || n.nodeType === 3) set.add(container(n));
          if (n.nodeType === 1 && !S.pure(n)) set.add(n);
        });
      } else if (r.type === 'characterData') {
        if (!done.has(r.target)) set.add(container(r.target));
      } else if (r.type === 'attributes') {
        if (S.ATTRS.indexOf(r.attributeName) > -1 || r.attributeName === 'value') attrs(r.target); else { swapEl(r.target); swapVid(r.target); }
      }
    });
    busy = true;
    try {
      var fb = !loading();
      set.forEach(function (c) { if (c && c.isConnected !== false) processRoot(c, fb); });
    } finally { busy = false; mo.takeRecords(); }
  });
  var OPTS = { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: S.ATTRS.concat(['value', 'src', 'srcset', 'data-src', 'data-srcset', 'href', 'poster']) };
  mo.observe(document.documentElement, OPTS);

  /* guide des tailles de bague : tailles locales (Espagne / Italie = taille française - 40) */
  function ringGuide() {
    var R = window.SX_RING; if (!R) return;
    document.querySelectorAll('table.sg-table').forEach(function (t) {
      if (t.getAttribute('data-sx-ring')) return; t.setAttribute('data-sx-ring', '1');
      var th = t.querySelector('thead th'); if (th) th.textContent = R.label;
      t.querySelectorAll('tbody tr').forEach(function (tr) {
        var td = tr.querySelector('td'); if (!td) return;
        var n = parseInt(td.textContent, 10); if (n >= 40) td.textContent = String(n + R.offset);
      });
    });
  }
  function full() { ringGuide(); busy = true; try { processRoot(document.body, true); title(); } finally { busy = false; mo.takeRecords(); } }
  document.addEventListener('DOMContentLoaded', function () { full(); setTimeout(function () { deferReady = true; full(); }, 0); });
  window.addEventListener('load', function () { deferReady = true; full(); });
  /* certaines applis (cookies…) créent leur contenu après le chargement : on revérifie pendant 20 s */
  var ticks = 0, iv = setInterval(function () { if (++ticks > 20) return clearInterval(iv); if (document.body) { busy = true; try { shadows(document.body); } finally { busy = false; mo.takeRecords(); } } }, 1000);
  window.SXI18N.retranslate = full;
})();
